import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface X2PropRecModel extends BaseModel {
  variables?: { [key: string]: string } | X2PropRecVariables;
}

export interface X2PropRecVariables {
  X2PropRec1Image: string;
  X2PropRec2Image: string;
  X2PropRec1ImageHref: string;
  X2PropRec2ImageHref: string;
  X2PropRec1ImageAlt: string;
  X2PropRec2ImageAlt: string;
  X2PropRec1Destination: string;
  X2PropRec2Destination: string;
  X2PropRec1Name: string;
  X2PropRec2Name: string;
  X2PropRec1CtaLink: string;
  X2PropRec2CtaLink: string;
  X2PropRec1CtaText: string;
  X2PropRec2CtaText: string;
  X2PropRec1ImageHrefSegmentRegex: string;
  X2PropRec2ImageHrefSegmentRegex: string;
  X2PropRec1CtaLinkSegmentRegex: string;
  X2PropRec2CtaLinkSegmentRegex: string;
}

export class X2PropRecInitVariables implements X2PropRecVariables {
  X2PropRec1Image = '';
  X2PropRec2Image = '';
  X2PropRec1ImageHref = '';
  X2PropRec2ImageHref = '';
  X2PropRec1ImageAlt = '';
  X2PropRec2ImageAlt = '';
  X2PropRec1Destination = '';
  X2PropRec2Destination = '';
  X2PropRec1Name = '';
  X2PropRec2Name = '';
  X2PropRec1CtaLink = '';
  X2PropRec2CtaLink = '';
  X2PropRec1CtaText = '';
  X2PropRec2CtaText = '';
  X2PropRec1ImageHrefSegmentRegex = '';
  X2PropRec2ImageHrefSegmentRegex = '';
  X2PropRec1CtaLinkSegmentRegex = '';
  X2PropRec2CtaLinkSegmentRegex = '';
}

export class X2PropRecInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new X2PropRecInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
